"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = require("./component");
exports.ScrollLocky = component_1.ScrollLocky;
exports.ScrollLockyPane = component_1.ScrollLockyPane;
var utils_1 = require("./utils");
exports.getGapWidth = utils_1.getGapWidth;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scroll-locky/dist/index.js
// module id = 434
// module chunks = 58